"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ExchangeList',
  props: {
    memberData: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      // 搜索表单数据
      searchForm: {
        status: ''
      },
      // 表格数据
      tableData: [{
        orderNo: '7789',
        type: '积分',
        memberPhone: '15188241230',
        product: '85折优惠券',
        points: '84',
        exchangeTime: '2025-07-09',
        status: 'completed'
      }],
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 100
    };
  },
  methods: {
    // 搜索功能
    handleSearch: function handleSearch() {
      console.log('搜索兑换记录:', this.searchForm);
      this.$message.success('搜索兑换记录');
      // TODO: 实现搜索逻辑
    },
    // 批量操作
    handleBatchOperation: function handleBatchOperation() {
      this.$message.info('批量操作功能');
      // TODO: 实现批量操作逻辑
    },
    // 导出功能
    handleExport: function handleExport() {
      this.$message.success('正在下载清单...');
      // TODO: 实现导出逻辑
    },
    // 获取状态标签样式
    getStatusTagType: function getStatusTagType(status) {
      var statusMap = {
        'pending': 'warning',
        'completed': 'success',
        'cancelled': 'danger'
      };
      return statusMap[status] || 'info';
    },
    // 获取状态文本
    getStatusText: function getStatusText(status) {
      var statusMap = {
        'pending': '待处理',
        'completed': '已完成',
        'cancelled': '已取消'
      };
      return statusMap[status] || '未知状态';
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
      // TODO: 重新获取数据
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      console.log("\u5F53\u524D\u9875: ".concat(val));
      // TODO: 重新获取数据
    }
  },
  mounted: function mounted() {
    // 如果传入了会员数据，可以根据会员信息过滤数据
    if (this.memberData) {
      console.log('兑换列表 - 会员信息:', this.memberData);
      // 可以根据会员信息筛选兑换数据
    }
    // TODO: 初始化时获取兑换记录数据
  }
};